import { CombinedText, DTableProps } from '@darwin-ui';
import { TFunction } from 'i18next';
import { MassiveTransactionErrorResponse } from 'types/massiveTransactionTypes';
import styles from './ErrorDetails.module.css';

export const getErrorDetailsColumns = (
  t: TFunction
): DTableProps<MassiveTransactionErrorResponse>['columns'] => [
  {
    title: t('error-details.columns.rowNumber'),
    dataIndex: 'row',
    key: 'row',
    sorter: true,
    width: 190,
    render: (_: unknown, record: MassiveTransactionErrorResponse) => (
      <CombinedText lines={1} text={record.row.toString()} />
    ),
  },
  {
    title: t('error-details.columns.errorMessage'),
    dataIndex: 'errorMessage',
    key: 'errorMessage',
    sorter: true,
    width: 190,
    render: (_: unknown, record: MassiveTransactionErrorResponse) => {
      return (
        <CombinedText
          lines={1}
          className={styles.errorMessage}
          text={t(`error-details.error-message.${record.errorCode}`, {
            fila: record.row,
            value: record.errorMessage.match(/"([^"]+)"/)?.[1] || '',
            column: record.column,
          })}
        />
      );
    },
  },
  {
    title: t('error-details.columns.suggestion'),
    dataIndex: 'suggestion',
    key: 'suggestion',
    sorter: true,
    width: 190,
    render: (_: unknown, record: MassiveTransactionErrorResponse) => (
      <CombinedText
        lines={1}
        text={t(`error-details.errors-suggestions.${record.errorCode}`)}
      />
    ),
  },
];
